var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoBox",staticClass:"vap-video-box",style:({ 'z-index': _vm.isPlaying ? 1 : -1 })})}
var staticRenderFns = []

export { render, staticRenderFns }